import React from "react";
import { Select } from "../../../components";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import { Tab, Tabs } from "@mui/material";
import TabProducts from "./components/TabProducts";
import TabTransaction from "./components/TabTransaction";
import {
  DEFAULT_LIST_NAME,
  useProductList,
} from "../../../hooks/useProductList";
import { useProduct } from "../../../hooks/useProduct";
import TabDashboard from "./components/TabDashboard";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Setting = () => {
  const [tabValue, setTabValue] = React.useState(0);

  const { current, changeCurrentProductList, productList } = useProductList();
  const { products, setProducts, allProducts } = useProduct();

  const [selectValue, setSelectValue] = React.useState(current);
  const [options, setOptions] = React.useState(productList);

  const changeProductList = (listName: string) => {
    changeCurrentProductList(listName);
  };

  return (
    <Box>
      <Paper elevation={0}>
        <Select
          value={selectValue}
          onChange={changeProductList}
          options={options}
        />
      </Paper>
      <Paper sx={{ mt: 1 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={(_, newValue) => setTabValue(newValue)}
            aria-label="basic tabs example"
          >
            <Tab label="儀表板" {...a11yProps(0)} />
            <Tab label="商品" {...a11yProps(1)} />
            <Tab label="交易記錄" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={tabValue} index={0}>
          <TabDashboard />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <TabProducts
            selectValue={selectValue}
            allProducts={allProducts}
            products={products}
            setProducts={setProducts}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={2}>
          <TabTransaction />
        </CustomTabPanel>
      </Paper>
    </Box>
  );
};

export default Setting;
